<div class="modal-header" *ngIf="showAsDialog" ngxModalDraggable>
    <h4 class="modal-title">Part Detail</h4>
</div>

<div class="page-content-small mt-1 flex-fill d-flex flex-column" *ngIf="part">
    <div class="d-flex mt-0 mb-1">
        <button accesskey="s" (click)="save(true)" class="btn btn-primary me-2" *ngIf="hasChanges() && !showAsDialog && !readOnly">Save</button>
        <button (click)="cancel()" class="btn btn-success" *ngIf="hasChanges() && !showAsDialog">Cancel</button>
        <button accesskey="c" (click)="close()" class="btn btn-primary" *ngIf="(!hasChanges() && !partTreeChanged) || (showAsDialog && !createSubPartMode)">Close</button>
        <button (click)="submitChanges()" class="btn btn-danger ms-2" *ngIf="partTreeChanged && !readOnly">Submit Changes</button>
        <button (click)="auditLog()" class="btn btn-info ms-auto" *ngIf="!hasChanges() && !partTreeChanged && !showAsDialog && !readOnly">Audit Log</button>
    </div>
    <dx-form [formData]="part" appAutofocusForm="partNumber" [colCount]="8">
        <dxi-item itemType="group" [colSpan]="2" [disabled]="readOnly">
            <dxi-item [label]="{ text: 'Part Number' }">
                <div *dxTemplate class="d-flex align-items-start">
                    <dx-text-area [(value)]="part.partNumber" [height]="68" class="flex-fill"></dx-text-area>
                </div>
            </dxi-item>
            <dxi-item [label]="{ text: 'Description' }">
                <div *dxTemplate class="d-flex align-items-start">
                    <dx-text-area [(value)]="part.description" [height]="68" class="flex-fill"></dx-text-area>
                </div>
            </dxi-item>
            <dxi-item dataField="category"></dxi-item>
            <dxi-item itemType="group" [colCount]="2" [disabled]="readOnly">
                <dxi-item dataField="buildTime"></dxi-item>
                <dxi-item dataField="assemblyTime"></dxi-item>
                <dxi-item dataField="revision"></dxi-item>
                <dxi-item dataField="trackInventory" editorType="dxCheckBox"></dxi-item>
                <dxi-item dataField="fontColor" editorType="dxColorBox" [editorOptions]="{ editAlphaChannel: true }"> </dxi-item>
                <dxi-item [label]="{ text: 'ParentId' }">
                    <div *dxTemplate>
                        <a href="#" (click)="partParentDetailRedirect(part.parentPartId)">{{ part.parentPartId || '' }}</a>
                    </div>
                </dxi-item>
            </dxi-item>
        </dxi-item>
        <dxi-item itemType="group" [colSpan]="2" [disabled]="readOnly">
            <dxi-item dataField="mfgPartNumber" [label]="{ text: 'GT Part#' }"></dxi-item>
            <dxi-item dataField="mfgDescription" [label]="{ text: 'GT Desc' }"></dxi-item>
            <dxi-item dataField="preferredVendor"></dxi-item>
            <dxi-item
                dataField="vendorId"
                [label]="{ text: 'Vendor Link' }"
                editorType="dxSelectBox"
                [editorOptions]="{ items: vendors, valueExpr: 'id', displayExpr: 'companyName' }"
                (onValueChanged)="onVendorSelection($event)"
            >
            </dxi-item>

            <dxi-item dataField="vINPrefix" [label]="{ text: 'VIN Prefix' }"></dxi-item>
            <dxi-item
                dataField="frameId"
                [label]="{ text: 'Frame' }"
                editorType="dxSelectBox"
                [editorOptions]="{ items: frames, valueExpr: 'id', displayExpr: 'partNumber', showClearButton: false }"
            ></dxi-item>
            <dxi-item
                dataField="quickBooksAccountId"
                [label]="{ text: 'QuickBooks Account' }"
                editorType="dxSelectBox"
                [editorOptions]="{ items: quickBooksAccounts, valueExpr: 'id', displayExpr: 'name', showClearButton: true }"
            ></dxi-item>
        </dxi-item>
        <dxi-item itemType="group" [colSpan]="1" [colCount]="1" [disabled]="readOnly">
            <dxi-item dataField="tierPricingOverride"></dxi-item>
            <dxi-item
                dataField="price"
                [label]="{ text: '(Old)Dealer' }"
                editorType="dxNumberBox"
                [editorOptions]="{ format: '$#,##0.00##', disabled: true }"
                [visible]="canSeePricing"
            ></dxi-item>
            <dxi-item
                dataField="retailPrice"
                editorType="dxNumberBox"
                [editorOptions]="{ format: '$#,##0.00##', disabled: !canUpdatePricing }"
                [visible]="canSeePricing"
            ></dxi-item>
            <dxi-item
                dataField="tier1"
                [label]="{ text: 'Tier 1 (Base)' }"
                editorType="dxNumberBox"
                [editorOptions]="{ format: '$#,##0.00##', disabled: true }"
                [visible]="canSeePricing"
            ></dxi-item>
            <dxi-item
                dataField="tier2"
                [label]="{ text: 'Tier 2 (Dealer)' }"
                editorType="dxNumberBox"
                [editorOptions]="{ format: '$#,##0.00##', disabled: true }"
                [visible]="canSeePricing"
            ></dxi-item>
            <dxi-item dataField="tier3" editorType="dxNumberBox" [editorOptions]="{ format: '$#,##0.00##', disabled: true }" [visible]="canSeePricing"></dxi-item>
            <dxi-item dataField="tier4" editorType="dxNumberBox" [editorOptions]="{ format: '$#,##0.00##', disabled: true }" [visible]="canSeePricing"></dxi-item>
            <dxi-item dataField="tier5" editorType="dxNumberBox" [editorOptions]="{ format: '$#,##0.00##', disabled: true }" [visible]="canSeePricing"></dxi-item>
        </dxi-item>

        <dxi-item itemType="group" [colSpan]="1" [colCount]="1" [disabled]="readOnly">
            <dxi-item dataField="cost" editorType="dxNumberBox" [editorOptions]="{ format: '$#,##0.00##', disabled: !canUpdateCost }" [visible]="canSeeCost"></dxi-item>
            <dxi-item *ngIf="part" [label]="{ text: 'Parts Cost' }" [visible]="canSeeCost">
                <div *dxTemplate>
                    <dx-number-box [(value)]="partsCalculatedCost" [hidden]="!canSeeCost" [disabled]="true" [format]="{ type: 'currency', precision: 2 }"></dx-number-box>
                </div>
            </dxi-item>
            <dxi-item *ngIf="part" [label]="{ text: 'Services Cost' }" [visible]="canSeeCost">
                <div *dxTemplate>
                    <dx-number-box [(value)]="servicesCost" [hidden]="!canSeeCost" [disabled]="true" [format]="{ type: 'currency', precision: 2 }"></dx-number-box>
                </div>
            </dxi-item>
            <dxi-item [label]="{ text: 'Calc. Cost' }" *ngIf="part" [visible]="canSeeCost">
                <div *dxTemplate>
                    <dx-number-box [(value)]="partCost" [hidden]="!canSeeCost" [disabled]="true" [format]="{ type: 'currency', precision: 2 }"></dx-number-box>
                </div>
            </dxi-item>
            <!-- <dxi-item
                dataField="calculatedCost"
                [label]="{ text: 'Stored Calc. Cost' }"
                editorType="dxNumberBox"
                [editorOptions]="{ format: { type: 'currency', precision: 5 }, disabled: true }"
                [visible]="canSeeCost"
            ></dxi-item> -->
            <!-- <dxi-item *ngIf="part" [label]="{ text: 'Parts Cost' }" [visible]="canSeeCost">
                <div *dxTemplate>
                    <dx-number-box [(value)]="partsCost" [hidden]="!canSeeCost" [disabled]="true" [format]="{ type: 'currency', precision: 2 }"></dx-number-box>
                </div>
            </dxi-item> -->

            <!-- <dxi-item
                dataField="price"
                [label]="{ text: 'Dealer' }"
                editorType="dxNumberBox"
                [editorOptions]="{ format: '$#,##0.00##', disabled: !canUpdatePricing }"
                [visible]="canSeePricing"
            ></dxi-item>
            <dxi-item
                dataField="retailPrice"
                editorType="dxNumberBox"
                [editorOptions]="{ format: '$#,##0.00##', disabled: !canUpdatePricing }"
                [visible]="canSeePricing"
            ></dxi-item> -->
            <dxi-item dataField="inStock" [label]="{ text: 'Proj.Inv.' }" [editorOptions]="{ disabled: true }"></dxi-item>
            <!-- <dxi-item dataField="isAssembly"></dxi-item> -->
            <dxi-item dataField="reOrderMinimum"></dxi-item>
            <dxi-item dataField="reOrderQuantity"></dxi-item>
        </dxi-item>
        <!-- <dxi-item itemType="group" [colSpan]="1" [colCount]="1" [disabled]="readOnly"> -->
        <!-- <dxi-item dataField="reOrderMinimum"></dxi-item> -->
        <!-- <dxi-item dataField="reOrderQuantity"></dxi-item> -->
        <!-- <dxi-item dataField="trackInventory" editorType="dxCheckBox"></dxi-item> -->
        <!-- <dxi-item dataField="fontColor" editorType="dxColorBox" [editorOptions]="{ editAlphaChannel: true }"> </dxi-item> -->
        <!-- <dxi-item [label]="{ text: 'ParentId' }">
                <div *dxTemplate>
                    <a href="#" (click)="partParentDetailRedirect(part.parentPartId)">{{ part.parentPartId || '' }}</a>
                </div>
            </dxi-item> -->
        <!-- </dxi-item> -->
        <dxi-item itemType="group" [colSpan]="2" [colCount]="1" [disabled]="readOnly">
            <dxi-item [label]="{ text: 'Part Notes' }">
                <div *dxTemplate class="d-flex align-items-start">
                    <dx-text-area [(value)]="part.note" [height]="150" class="flex-fill"></dx-text-area>
                </div>
            </dxi-item>
            <dxi-item dataField="unitOfMeasure"></dxi-item>
            <dxi-item itemType="group" [colCount]="2" [disabled]="readOnly">
                <dxi-item dataField="isAssembly"></dxi-item>
                <dxi-item dataField="isNonManufactured" [label]="{ text: 'Non Manufactured' }"></dxi-item>
                <dxi-item dataField="isFreight"></dxi-item>
                <dxi-item dataField="prePaymentDiscountOverride"></dxi-item>
                <dxi-item dataField="tierPricingOverride"></dxi-item>
            </dxi-item>
        </dxi-item>

        <div class="col-sm-4 mt-3"></div>
    </dx-form>

    @if (!createSubPartMode) {
        <dx-tab-panel class="flex-fill d-flex flex-column mt-3">
            <dxi-item [title]="'Part Tree'" class="flex-fill d-flex flex-column pt-3">
                <dx-tree-list
                    class="grid-fill p-2"
                    #subPartsTree
                    id="orderLines"
                    [dataSource]="orderLines"
                    keyExpr="id"
                    itemsExpr="children"
                    dataStructure="tree"
                    [showRowLines]="true"
                    [showBorders]="true"
                    [columnAutoWidth]="true"
                    (onToolbarPreparing)="onToolbarPreparing($event)"
                    (onExporting)="onExporting($event)"
                    [autoExpandAll]="false"
                    height="400"
                >
                    <dxi-column dataField="partNumber" caption="Part Number" [width]="275" cellTemplate="linkTemplate"></dxi-column>
                    <dxi-column dataField="category" caption="Category" [width]="100"></dxi-column>
                    <dxi-column dataField="quantity" [width]="80"></dxi-column>
                    <dxi-column dataField="id" [width]="80"></dxi-column>
                    <dxi-column dataField="extendedQuantity" [width]="80"></dxi-column>
                    <dxi-column
                        dataField="cost"
                        caption="Cost"
                        [width]="80"
                        [format]="{ type: 'currency', precision: 6 }"
                        cellTemplate="costLinkTemplate"
                        [visible]="canSeeCost"
                    ></dxi-column>
                    <dxi-column
                        dataField="calculatedCost"
                        caption="Calc. Cost"
                        [width]="80"
                        [format]="{ type: 'currency', precision: 6 }"
                        cellTemplate="costLinkTemplate"
                        [visible]="canSeeCost"
                    ></dxi-column>
                    <dxi-column dataField="partId" [width]="80"></dxi-column>
                    <dxi-column dataField="isAssembly" caption="Asm" [width]="80"></dxi-column>
                    <dxi-column dataField="description" caption="Description" [width]="300"></dxi-column>

                    <dxo-filter-row [visible]="true"></dxo-filter-row>
                    <dxo-search-panel [visible]="true"></dxo-search-panel>
                    <dxo-export [enabled]="true"></dxo-export>

                    <div *dxTemplate="let cell of 'linkTemplate'">
                        <a [routerLink]="[]" class="{{ cell.data.isAssembly ? 'text-red' : '' }}" (click)="edit(cell.data)">{{ cell.text }}</a>
                    </div>
                    <div *dxTemplate="let cell of 'costLinkTemplate'">
                        <a [routerLink]="[]" (click)="editCost(cell.data)">{{ cell.text }}</a>
                    </div>

                    <div *dxTemplate="let data of 'toolbarButtons'">
                        <button class="btn btn-success ms-2" (click)="addMultiple()" [hidden]="!canEditPartTree || showAsDialog">Add</button>
                        <button
                            class="btn btn-danger ms-2"
                            (click)="delete(subPartsTree.instance.getSelectedRowsData()[0])"
                            [disabled]="subPartsTree.instance.getSelectedRowsData().length !== 1"
                            [hidden]="!canEditPartTree || showAsDialog"
                        >
                            Delete
                        </button>
                        <button
                            class="btn btn-danger ms-2"
                            (click)="setAsAssembly(subPartsTree.instance.getSelectedRowsData()[0])"
                            [disabled]="subPartsTree.instance.getSelectedRowsData().length !== 1"
                            [hidden]="!canEditPartTree || showAsDialog"
                        >
                            Toggle Assembly
                        </button>
                        <button class="btn btn-success ms-2" (click)="expand()">
                            {{ expanded ? 'Collapse' : 'Expand' }}
                        </button>
                        <button class="btn btn-sm btn-secondary ms-4" (click)="printPartDetail()">Print Part Detail</button>
                        <button class="btn btn-sm btn-secondary ms-1" (click)="printPartDetail(true)">Print Part Detail (TopLevel)</button>
                        <button
                            class="btn btn-sm btn-warning ms-3"
                            (click)="convertToService()"
                            [disabled]="subPartsTree.instance.getSelectedRowsData().length !== 1"
                            [hidden]="!auth.hasRole('Administrator')"
                        >
                            Convert to Service
                        </button>
                        <button class="btn btn-sm btn-primary ms-3" (click)="refresh()">Refresh</button>
                    </div>
                </dx-tree-list>
            </dxi-item>
            <dxi-item [title]="'Service Charges'" class="flex-fill d-flex flex-column p-3">
                <dx-data-grid #servicesGrid [dataSource]="serviceChargeLinks" keyExpr="id" class="grid-fill" [showBorders]="true" (onToolbarPreparing)="onToolbarPreparing($event)">
                    <dxi-column dataField="partServiceCharge.name" caption="Service Charge" width="225"></dxi-column>
                    <dxi-column dataField="cost" [format]="{ type: 'currency', precision: 5 }" width="175"></dxi-column>
                    <dxi-column></dxi-column>

                    <div *dxTemplate="let data of 'toolbarButtons'">
                        <button class="btn btn-sm btn-success" (click)="addServiceCharge()" [hidden]="readOnly || showAsDialog">Add</button>

                        <button
                            class="btn btn-sm btn-primary ms-2"
                            (click)="addServiceCharge(servicesGrid.instance.getSelectedRowsData()[0])"
                            [disabled]="servicesGrid.instance.getSelectedRowsData().length !== 1"
                            [hidden]="readOnly || showAsDialog"
                        >
                            Edit
                        </button>

                        <button
                            class="btn btn-sm btn-danger ms-2"
                            (click)="deleteServiceCharge(servicesGrid.instance.getSelectedRowsData()[0])"
                            [disabled]="servicesGrid.instance.getSelectedRowsData().length !== 1"
                            [hidden]="readOnly || showAsDialog"
                        >
                            Delete
                        </button>
                    </div>
                    <dxo-column-chooser [enabled]="false"></dxo-column-chooser>
                    <dxo-summary>
                        <dxi-total-item column="cost" summaryType="sum" [valueFormat]="{ type: 'currency', precision: 5 }"> </dxi-total-item>
                    </dxo-summary>
                </dx-data-grid>
            </dxi-item>
            <dxi-item [title]="'Part Types'" class="flex-fill d-flex flex-column p-3">
                <dx-data-grid
                    #partTypesGrid
                    [dataSource]="part.partPartTypes"
                    keyExpr="id"
                    class="grid-fill"
                    [showBorders]="true"
                    (onToolbarPreparing)="onToolbarPreparing($event)"
                >
                    <dxi-column dataField="partType.name" caption="Part Type" [sortIndex]="0" sortOrder="asc"></dxi-column>

                    <div *dxTemplate="let data of 'toolbarButtons'">
                        <button class="btn btn-sm btn-success" (click)="addPartType()" [hidden]="readOnly || showAsDialog">Add</button>
                        <button
                            class="btn btn-sm btn-danger ms-2"
                            (click)="deletePartType(partTypesGrid.instance.getSelectedRowsData()[0])"
                            [disabled]="partTypesGrid.instance.getSelectedRowsData().length !== 1"
                            [hidden]="readOnly || showAsDialog"
                        >
                            Remove
                        </button>
                    </div>
                    <dxo-selection [mode]="'single'"></dxo-selection>
                    <dxo-state-storing [enabled]="true" type="localStorage" storageKey="part-detail-grid"></dxo-state-storing>
                    <dxo-column-chooser [enabled]="false"></dxo-column-chooser>
                </dx-data-grid>
            </dxi-item>
            <dxi-item [title]="'Part Options'" class="flex-fill d-flex flex-column p-3">
                <dx-data-grid #optionsGrid [dataSource]="options" keyExpr="id" class="grid-fill" [showBorders]="true" (onToolbarPreparing)="onToolbarPreparing($event)">
                    <dxi-column dataField="optionPart.partNumber" caption="Part Number" width="370"></dxi-column>
                    <dxi-column dataField="optionPart.description" caption="Description" width="370"></dxi-column>
                    <dxi-column dataField="displayOrder" width="110"></dxi-column>

                    <div *dxTemplate="let data of 'toolbarButtons'">
                        <button class="btn btn-sm btn-success" (click)="addOption()" [hidden]="readOnly || showAsDialog">Add</button>
                        <button
                            class="btn btn-sm btn-danger ms-2"
                            (click)="deleteOption(optionsGrid.instance.getSelectedRowsData()[0])"
                            [disabled]="optionsGrid.instance.getSelectedRowsData().length !== 1"
                            [hidden]="readOnly || showAsDialog"
                        >
                            Delete
                        </button>
                    </div>
                    <dxo-selection [mode]="'single'"></dxo-selection>
                    <dxo-row-dragging [allowReordering]="true" [onReorder]="onReorder" [showDragIcons]="false"></dxo-row-dragging>
                    <dxo-state-storing [enabled]="true" type="localStorage" storageKey="part-detail-options-grid"></dxo-state-storing>
                    <dxo-column-chooser [enabled]="false"></dxo-column-chooser>
                </dx-data-grid>
            </dxi-item>
            <dxi-item [title]="'Part Children'" class="flex-fill d-flex flex-column p-3">
                <dx-data-grid #childrenGrid [dataSource]="childrenParts" keyExpr="id" class="grid-fill" [showBorders]="true" (onToolbarPreparing)="onToolbarPreparing($event)">
                    <dxi-column dataField="partNumber" caption="Part Number"></dxi-column>
                    <dxi-column dataField="onOrder"></dxi-column>
                    <dxi-column dataField="description" width="110"></dxi-column>
                    <dxi-column dataField="cost" format="$#,##0.00"></dxi-column>
                    <dxi-column dataField="preferredVendor" width="110"></dxi-column>

                    <div *dxTemplate="let data of 'toolbarButtons'">
                        <button class="btn btn-sm btn-success" (click)="addChildPart()" [hidden]="readOnly || showAsDialog">Add</button>
                        <button
                            class="btn btn-sm btn-danger ms-2"
                            (click)="deleteChildPart(childrenGrid.instance.getSelectedRowsData()[0])"
                            [disabled]="childrenGrid.instance.getSelectedRowsData().length !== 1"
                            [hidden]="readOnly || showAsDialog"
                        >
                            Delete
                        </button>
                    </div>
                    <dxo-selection [mode]="'single'"></dxo-selection>
                    <dxo-state-storing [enabled]="true" type="localStorage" storageKey="part-detail-children-grid"></dxo-state-storing>
                    <dxo-column-chooser [enabled]="false"></dxo-column-chooser>
                </dx-data-grid>
            </dxi-item>
            <dxi-item [title]="'Part Aliases'" class="flex-fill d-flex flex-column p-3">
                <dx-data-grid
                    #aliasesGrid
                    [dataSource]="partAliases"
                    keyExpr="id"
                    class="grid-fill"
                    [showBorders]="true"
                    (onToolbarPreparing)="onToolbarPreparing($event)"
                    (onRowDblClick)="onAliasDoubleClick($event)"
                >
                    <dxi-column dataField="partAliasType.name" caption="Type"></dxi-column>
                    <dxi-column dataField="vendor.companyName" caption="Vendor"></dxi-column>
                    <dxi-column dataField="partNumber" caption="Mfg Part#"></dxi-column>
                    <dxi-column dataField="description" caption="Description" width="110"></dxi-column>
                    <dxi-column dataField="cost" format="$#,##0.00"></dxi-column>
                    <dxi-column dataField="packageQuantity"></dxi-column>
                    <dxi-column dataField="quickBooksLineItem.name" caption="Line Item" width="125"></dxi-column>
                    <dxi-column></dxi-column>

                    <div *dxTemplate="let data of 'toolbarButtons'">
                        <button class="btn btn-sm btn-success" (click)="editAlias()" [hidden]="readOnly || showAsDialog">Add</button>
                        <button
                            class="btn btn-sm btn-primary ms-2"
                            (click)="editAlias(aliasesGrid.instance.getSelectedRowsData()[0])"
                            [disabled]="aliasesGrid.instance.getSelectedRowsData().length !== 1"
                            [hidden]="readOnly || showAsDialog"
                        >
                            Edit
                        </button>
                        <button
                            class="btn btn-sm btn-danger ms-2"
                            (click)="deleteAlias(aliasesGrid.instance.getSelectedRowsData()[0])"
                            [disabled]="aliasesGrid.instance.getSelectedRowsData().length !== 1"
                            [hidden]="readOnly || showAsDialog"
                        >
                            Delete
                        </button>
                    </div>
                    <dxo-selection [mode]="'single'"></dxo-selection>
                    <dxo-state-storing [enabled]="true" type="localStorage" storageKey="part-alias-grid"></dxo-state-storing>
                    <dxo-column-chooser [enabled]="false"></dxo-column-chooser>
                </dx-data-grid>
            </dxi-item>
            <dxi-item [title]="'Manual Cost History'" [visible]="canSeeCost" class="flex-fill d-flex flex-column p-3">
                <dx-data-grid [dataSource]="costHistory" keyExpr="id" class="grid-fill" [showBorders]="true" [wordWrapEnabled]="true">
                    <dxi-column dataField="created" caption="Date" dataType="datetime" width="160" sortOrder="desc"></dxi-column>
                    <dxi-column dataField="createdBy" caption="User" width="150"></dxi-column>
                    <dxi-column dataField="notes" caption="Change"></dxi-column>
                </dx-data-grid>
            </dxi-item>
            <dxi-item [title]="'Attachments'" class="flex-fill d-flex flex-column p-3">
                <dx-file-uploader
                    name="fileUpload"
                    selectButtonText="Select File(s)"
                    class="attachments"
                    accept="*"
                    uploadMode="instantly"
                    [showFileList]="false"
                    [multiple]="true"
                    [uploadUrl]="uploadUrl"
                    [uploadHeaders]="uploadHeader"
                    (onUploadStarted)="uploadStarted($event)"
                    (onUploadError)="uploadError($event)"
                    (onUploaded)="uploaded($event)"
                >
                </dx-file-uploader>
                @if (partAttachments) {
                    <ul style="list-style-type: none; padding-inline-start: 15px">
                        @for (attachment of partAttachments; track attachment) {
                            <li>
                                <a title="remove" (click)="removeAttachment($event, attachment)"> <i class="fa fa-times" aria-hidden="true"></i> </a>&nbsp;
                                <a title="view" (click)="openAttachment(attachment)">{{ attachment.name }}</a>
                            </li>
                        }
                    </ul>
                }
            </dxi-item>
        </dx-tab-panel>
    }
</div>
<dx-toast message="Changes Saved!" type="success" [displayTime]="1000" [maxWidth]="300" [position]="'bottom right'" [(visible)]="isToastVisible"> </dx-toast>
<div class="modal-footer" *ngIf="showAsDialog">
    @if (!createSubPartMode) {
        <button class="btn btn-success ms-1" (click)="closeDialog()">Close</button>
    }
    @if (createSubPartMode) {
        <button class="btn btn-success ms-1" (click)="closeDialog()">Cancel</button>
        <button class="btn btn-primary ms-1" (click)="saveDialog()">Save</button>
    }
</div>
